import {
    UpsertWeightLog,
    WeightLogResponse,
} from '@/shared/interfaces/api/sundvaegt-interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const upsertWeightLog = async (weightLogRequest: UpsertWeightLog) => {
    return await fetchIStatus<WeightLogResponse, UpsertWeightLog>(
        '/api/sundvaegt/log',
        'PUT',
        weightLogRequest,
    );
};
